import "./loading.less";
import {checkIsIframe} from "../utils/utils";

let $el;
let counter = 0;
const iframeOverride = checkIsIframe() ? window.top.zde.loading : {};

export default {
	/**
	 * Shows loading spinner
	 */
	show: function() {
		if (!$el) {
			$el = $('<div class="zloader"></div>').appendTo('body');
			/*$el = $(`<div class="zloader2">
	<div></div>
	<div></div>
	<div></div>
	</div>`).appendTo('body');*/
		}
		counter++;
	},

	/**
	 * Shows loading spinner
	 */
	hide: function() {
		if ($el && --counter <= 0) {
			$el.addClass('zloader-closing');
			// let animation finish and remove the element
			const $element = $el;
			setTimeout(() => {
				$element.remove();
			}, 1000);
			$el = null;
			counter = 0;
		}
	},

	...iframeOverride
}



// WEBPACK FOOTER //
// ./core/widgets/loading.js